// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — video-block.styled.classic.js, новая — video-block.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './video-block.styled.classic';
import * as cp from './video-block.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
export const VideoLink = isCp ? cp.VideoLink : classic.VideoLink;
export const WrapperVideo = isCp ? cp.WrapperVideo : classic.WrapperVideo;
